import type { CSSProperties } from 'react'

export const AVATAR_CONTAINER_PROPS: (keyof CSSProperties)[] = [
  'background',
  'backgroundColor',
  'opacity',
  'border',
  'borderRadius',
  'boxShadow',
  'margin',
  'padding',
]

export const AVATAR_GROUP_OFFSET = -3.5
